module.exports = __webpack_public_path__ + "img/add-to-jobs-blue.5ffdf889.svg";